exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-fcd9894c] {\n  font-size: 12px;\n  margin-top: 5px !important;\n  display: ruby-text !important;\n  color: black !important;\n}\n", ""]);

// exports
